/* eslint-disable react/jsx-no-bind */
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { useDebouncedCallback } from '@react-hookz/web';
import { Footer } from 'components/Footer/Footer';
import { Header } from 'components/Header/Header';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { useUserGroups } from 'dataLayer/Cognito';
import { dealsQuery } from 'dataLayer/Deal/get';
import { FunctionComponent, useState } from 'react';
import { useQuery } from 'react-query';
import { generatePath, Link as RouterLink, RouteProps } from 'react-router-dom';
import { PATHS } from 'Router';

export const DealsHome: FunctionComponent<RouteProps> = () => {
  const userGroups = useUserGroups();

  const [prefix, setPrefix] = useState('');
  const { data: deals, isLoading } = useQuery(dealsQuery(prefix));

  // TODO ADD COMMENT
  const updatePrefix = useDebouncedCallback(
    (input) => setPrefix(input ?? ''),
    [],
    600,
    0,
  );

  return (
    <>
      <Header />
      <TextField
        margin="normal"
        fullWidth
        id="outlined-search"
        label="Search by deal id"
        type="search"
        onChange={(event) => updatePrefix(event.target.value)}
      />
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Deal ID</TableCell>
                <TableCell>Company Name</TableCell>
                <TableCell>View Deal</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {deals?.map((deal) => (
                <TableRow
                  key={deal.id}
                  sx={{
                    boxShadow: '0px 1px 0px lightgray',
                  }}
                >
                  {/* Deal ID */}
                  <TableCell>{deal.id}</TableCell>

                  {/* Deal Name  */}
                  <TableCell>{deal.name}</TableCell>

                  <TableCell>
                    {/* View Documents Button (CSC only)  */}
                    {userGroups.includes('csc') && (
                      <Button
                        variant="outlined"
                        component={RouterLink}
                        to={generatePath(PATHS.DOCUMENTS, { dealId: deal.id })}
                        sx={{ marginRight: 1 }}
                      >
                        View Documents
                      </Button>
                    )}

                    {/* View Deal Button (CPA only) */}
                    {userGroups.includes('cpa') && (
                      <Button
                        variant="outlined"
                        component={RouterLink}
                        to={generatePath(PATHS.DEAL_CPA, { dealId: deal.id })}
                        sx={{ marginRight: 1 }}
                      >
                        View Deal
                      </Button>
                    )}

                    {/* View ERCA Button (ERCA Specialist only)  */}
                    {userGroups.includes('erca') && (
                      <Button
                        variant="outlined"
                        component={RouterLink}
                        to={generatePath(PATHS.ERCA, { dealId: deal.id })}
                        sx={{ marginRight: 1 }}
                      >
                        View ERCA
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Footer />
    </>
  );
};
